const CRM_BASE_URL =
  "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/";

const isCrmRequest = (input) => {
  const url = typeof input === "string" ? input : input?.url;
  return typeof url === "string" && url.startsWith(CRM_BASE_URL);
};

const fallbackResponse = () =>
  new Response(
    JSON.stringify({
      id: "crm-unavailable",
      crmSubmissionFailed: true,
    }),
    {
      status: 200,
      headers: { "Content-Type": "application/json" },
    }
  );

// Forms across the site submit directly to the CRM in several different ways.
// Make that integration best-effort everywhere, while preserving normal fetch
// behavior for every other service.
export const installCrmFailureFallback = () => {
  if (typeof window === "undefined" || !window.fetch || window.__crmFetchWrapped) {
    return;
  }

  const nativeFetch = window.fetch.bind(window);
  window.__crmFetchWrapped = true;

  window.fetch = async (...args) => {
    if (!isCrmRequest(args[0])) {
      return nativeFetch(...args);
    }

    try {
      const response = await nativeFetch(...args);

      if (response.ok) {
        return response;
      }

      console.error(
        "CRM submission failed; continuing form submission.",
        await response.clone().text()
      );
    } catch (error) {
      console.error("CRM submission failed; continuing form submission.", error);
    }

    return fallbackResponse();
  };
};
